module.exports = __webpack_public_path__ + "static/media/mars2.7bf85db4.jpg";